import { render, staticRenderFns } from "./LearnWorld.vue?vue&type=template&id=267c2232&scoped=true"
import script from "./LearnWorld.vue?vue&type=script&lang=js"
export * from "./LearnWorld.vue?vue&type=script&lang=js"
import style0 from "./LearnWorld.vue?vue&type=style&index=0&id=267c2232&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267c2232",
  null
  
)

export default component.exports